import { useFormularioSecretariaMunicipalAgriculturaStore, ProgramaAssistenciaTecnica } from '../../../../../../stores/forms/formularioAgricultura.store';

export const useStep7 = () => {
  const { formulario, setPartialForm, salvarRascunho } = useFormularioSecretariaMunicipalAgriculturaStore();

  const stepAtual = formulario?.step_atual ?? 1;
  const totalSteps = 8;

  // Programas cadastrados
  const programas = formulario?.programas_assistencia_tecnica || [];

  // Validação: deve ter pelo menos 1 programa cadastrado
  const podeAvancar = programas.length > 0;

  // Função para avançar para o próximo step
  const handleAvancar = async () => {
    if (!podeAvancar) return;
    setPartialForm('step_atual', stepAtual + 1);
    await salvarRascunho();
  };

  // Função para adicionar programa
  const adicionarPrograma = (programa: ProgramaAssistenciaTecnica) => {
    const programasAtuais = formulario?.programas_assistencia_tecnica || [];
    const novosProgramas = [...programasAtuais, programa];
    setPartialForm('programas_assistencia_tecnica', novosProgramas);
    salvarRascunho();
  };

  // Função para remover programa
  const removerPrograma = (id: string) => {
    const programasAtuais = formulario?.programas_assistencia_tecnica || [];
    const novosProgramas = programasAtuais.filter(p => p.id !== id);
    setPartialForm('programas_assistencia_tecnica', novosProgramas);
    salvarRascunho();
  };

  const handleVoltar = async () => {
    setPartialForm('step_atual', Math.max(1, stepAtual - 1));
    await salvarRascunho();
  };

  return {
    formulario,
    podeAvancar,
    handleAvancar,
    handleVoltar,
    stepAtual,
    totalSteps,
    setPartialForm,
    programas,
    adicionarPrograma,
    removerPrograma,
  };
};
